import { useCallback } from 'react';
import { toast } from 'react-hot-toast';

export const useOtherUserEditingToast = (): ((id?: string) => void) => {
  return useCallback((id?: string) => {
    toast.error('他のユーザが編集しています | Other user is editing', { id, duration: 5000 });
  }, []);
};
